export default [
  {
    path: 'clients',
    children: [
      {
        name: 'clients',
        path: '',
        component: () => import('./ClientsList.vue'),
        meta: {
          title: 'Members'
        }
      },
      {
        name: 'create-client',
        path: 'create',
        component: () => import('./ClientForm.vue'),
        meta: {
          title: 'New Member'
        },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-client',
        path: ':id/edit',
        component: () => import('./ClientForm.vue'),
        meta: {
          title: 'Edit Member'
        },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-client',
        path: ':id/view',
        component: () => import('./ClientView.vue'),
        meta: {
          title: 'View Member'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]

